import React, { useEffect, useRef, useState } from "react";
import PleaseLoginPrompt from "../../components/PleaseLoginPrompt";

const LoginPrompt = () => {
  const loginRef = useRef();

  const [mode, setMode] = useState("");

  const prompts = {
    favouriteEventGroup: {
      prompt: tickets_resources.SignInToFavourite,
      icon: "/site/images/icons/heart-favourite.png",
    },
  };

  const isAuthenticated = $("#__HD_RequestVerificationToken").length > 0;

  useEffect(() => {
    initHandlers();
    return () => {
      cleanupHandlers();
    };
  }, []);

  const initHandlers = () => {
    $(document).on("click", ".favourite-icn", handleFavouriteEventGroup);
  };

  const cleanupHandlers = () => {
    $(document).off("click", ".favourite-icn", handleFavouriteEventGroup);
  };

  const handleAuthAction = (action, input) => {
    if (!isAuthenticated) loginRef.current?.handleOpen();
    else action(input);
  };

  const handleFavouriteEventGroup = (e) => {
    e.stopPropagation();
    e.preventDefault();

    setMode("favouriteEventGroup");

    handleAuthAction((el) => {
      let nodeId = $(el).data("nodeid");

      if ($(el).hasClass("favourited")) {
        $.ajax(`/_api/follow/${nodeId}`, { type: "DELETE" });
        $(el).toggleClass("favourited").toggleClass("not-favourited").show();
      } else {
        $.post(`/_api/follow/${nodeId}`);
        $(el).toggleClass("favourited").toggleClass("not-favourited");
      }
    }, e.currentTarget);
  };

  return (
    <PleaseLoginPrompt
      prompt={prompts[mode]?.prompt}
      desc={prompts[mode]?.desc}
      icon={prompts[mode]?.icon}
      ref={loginRef}
    />
  );
};

export default LoginPrompt;
